import { ContentLoader } from '@ukpostbox/frontend-framework';
import React from 'react';
import { useMailbox } from '../../Providers/NewMailboxProvider';

function MailboxLoader() {
	const { gridView } = useMailbox();

	return gridView ? (
		<>
			<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
			<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
			<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
			<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
			<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
			<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
			<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
			<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
			<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
			<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
			<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
			<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
			<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
			<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
			<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
			<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
			<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
			<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
			<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
			<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
		</>
	) : (
		<ContentLoader childHeight='7em' />
	);
}

export { MailboxLoader };
